<div class="flex flex-col items-start space-y-4">
  <button
    pButton
    class="w-full bg-white rounded-md p-4 flex items-center space-x-4 border-none md:border-[1px] md:border-solid md:border-light"
    (click)="redirectToContactUs()">
    <i class="pi pi-chevron-right text-base"></i>
    <span class="font-bold text-base">{{ "contractCard.makeRequest" | translate }}</span>
  </button>
  <div
    *ngIf="isPolicyActive"
    class="w-full space-y-4">
    <button
      pButton
      [routerLink]="storedDocumentsPath"
      class="w-full bg-white rounded-md p-4 flex items-center space-x-4 border-none md:border-[1px] md:border-solid md:border-light">
      <i class="pi pi-file text-base"></i>
      <span class="font-bold text-base">{{ "serviceOfferings.mySpace" | translate }}</span>
    </button>

    <div
      *ngIf="isGdaAllowed"
      class="w-full space-y-4">
      @if (isLoading) {
        <p-skeleton
          size="2rem"
          styleClass="mr-2"
          *ngFor="let item of [1, 2]" />
      } @else {
        <div *ngFor="let claim of claims">
          <app-claims-button-mrh
            [policyReference]="this.policyReference"
            [claimsType]="claim.claimsType"
            [claimsRedirectValue]="claim.claimsRedirectValue"
            [text]="claim.text"
            [logo]="claim.logo">
          </app-claims-button-mrh>
        </div>
      }
    </div>
  </div>
</div>

